// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const AzureAksClusterTier = {
  AksClusterTierFree: 'free',
  AksClusterTierStandard: 'standard',
} as const;
export type AzureAksClusterTier =
  (typeof AzureAksClusterTier)[keyof typeof AzureAksClusterTier];

export function instanceOfAzureAksClusterTier(value: any): boolean {
  for (const key in AzureAksClusterTier) {
    if (Object.prototype.hasOwnProperty.call(AzureAksClusterTier, key)) {
      if (
        AzureAksClusterTier[key as keyof typeof AzureAksClusterTier] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function AzureAksClusterTierFromJSON(json: any): AzureAksClusterTier {
  return AzureAksClusterTierFromJSONTyped(json, false);
}

export function AzureAksClusterTierFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AzureAksClusterTier {
  return json as AzureAksClusterTier;
}

export function AzureAksClusterTierToJSON(
  value?: AzureAksClusterTier | null,
): any {
  return value as any;
}

export function AzureAksClusterTierToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): AzureAksClusterTier {
  return value as AzureAksClusterTier;
}
